import { render, staticRenderFns } from "./RolesAdd.vue?vue&type=template&id=2363c806&scoped=true"
import script from "./RolesAdd.vue?vue&type=script&lang=js"
export * from "./RolesAdd.vue?vue&type=script&lang=js"
import style0 from "./RolesAdd.vue?vue&type=style&index=0&id=2363c806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363c806",
  null
  
)

export default component.exports